<template>
  <div class="TransferStatuses__Widget" v-if="ready && filteredTransferStatusEvents.length">
    <b-collapse v-for="(status, index) in filteredTransferStatusEvents" :key="index" class="content" :open="false">
      <template #trigger="props">
        <div class="transfer-header">
          <div class="transfer-info">
            <div><b>מ:</b> {{ status.From }}</div>
            <div><b>ל:</b> {{ status.To }}</div>
          </div>
          <div class="header-actions">
            <b-icon :icon="props.open ? 'chevron-up' : 'chevron-down'" />
            <b-button :loading="isLoading" @click.stop="preview(status)">
              <b-icon icon="download-circle" />
            </b-button>
          </div>
        </div>
      </template>
      <div v-for="(event, idx) in status.Events" :key="idx" class="status-event">
        <div>
          <b>{{ event.TransferStatus.Name }}</b>
        </div>
        <div class="updated-by">
          <span class="datetime">{{ event.Date | date }}</span> | עודכן ע"י:
          <span> {{ event.UpdatingUserName ? event.UpdatingUserName : '-' }} </span>
        </div>
        <div v-if="event.BotError">
          <p style="width: 90px; margin: 0;"> {{ getEventErrorMessage(event) }} </p>
          <span> {{ event.BotError }} </span>
        </div>
        <div v-if="event.MissingDocumentsLink">
          <a :href="event.MissingDocumentsLink" target="_blank">להשלמת מסמכים</a>
        </div>
        <div v-if="event.ScannedPdfUrl">
          <a href="#" @click.prevent="downloadFile(event.ScannedPdfUrl)" title="מסמך סרוק מהמייל">
            <b-icon icon="file-document-outline" />
          </a>
        </div>
        <div class="reference" v-if="event.Reference">{{ event.Reference }}</div>
      </div>
    </b-collapse>
  </div>
  <h1 v-else>אין נתוני הסבה</h1>
</template>

<script>
import FilesService from "@/services/FilesService";
import VueIframeWritable from "@/components/VueIframeWritable.vue";
import LeasingCompaniesService from "@/services/LeasingCompaniesService";
import { ToastProgrammatic as Toast } from "buefy";
import moment from 'moment';
import printer from "../../plugins/printer";

export default {
  name: 'TransferStatusesCompanyWidget',
  props: ['ready', 'namespace', 'field'],
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    filteredTransferStatusEvents() {
      const transferStatusEvents = this.$store.state.report.Transfers;
      if (transferStatusEvents) {
        const statuses = transferStatusEvents.slice(0);
        return statuses;
      }
      return [];
      // statuses.forEach((status) => {
      //   status.Events.sort((a, b) => new Date(a.Date) - new Date(b.Date));
      // });
    },
  },
  filters: {
    date(value) {
      const date = moment(value, 'YYYY-MM-DDThh:mm');
      return date.format('DD/MM/YYYY HH:mm');
    },
  },
  methods: {
    init() {
      this.$emit('onReady');
    },
    preview(status) {
      const loadingComponent = this.$buefy.loading.open();
      const scrollPosition = document.body.querySelector('.table-wrapper')?.scrollTop;
      LeasingCompaniesService.printTransfersByBatchItemId([status.Id])
        .then((r) => {
          this.$iframe.open({
            html: r.data?.Html,
            component: VueIframeWritable,
            onSave: async ({ close, loading }) => {
              loading(true);
              this.downloadFile(status.TransferPdfUrl).finally(() => {
                loading(false);
                close();
              });
            },
            onPrint: async ({ loading }) => {
              loading(true);
              printer.printHtml(r.data.Html, scrollPosition);
              loading(false);
            },
          });
        })
        .finally(() => {
          loadingComponent.close();
        });
    },
    getEventErrorMessage(event) {
      if (event.UpdatingUserName === 'transferBot') {
        if (event.BotError !== null) return 'שגיאה מהבוט:';
        return 'הודעה מהבוט:';
      }
      if (event.BotError !== null) return 'שגיאה מהAPI:';
      return 'הודעה מהAPI:';
    },
    downloadFile(url) {
      this.isLoading = true;
      return FilesService.getTransferPdf(url, {
        // headers: { "Profile-Id": this.item.Owner.Id },
      })
        .then((r) => {
          FilesService.saveResponseFile(r, "הסבה.pdf");
        })
        .catch(() => {
          Toast.open({
            type: "is-danger",
            message: "המערכת נתקלה בבעיה! יש לנסות שוב או לפנות לתמיכה הטכנית.",
            position: "is-bottom",
            duration: 8000,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  watch: {
    ready(newValue) {
      if (newValue) {
        this.init();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.TransferStatuses__Widget {
  width: 100%;

  .content {
    border-radius: 4px;
    margin: 6px 0;
    border: 1px solid #e0e0e0;

    /deep/ .collapse-content {
      display: flex;
      flex-direction: column;
      padding: 0 8px 6px;
    }

    .status-event {
      padding: 4px 12px;
      position: relative;

      &::before {
        content: '';
        position: absolute;
        top: 15px;
        right: -8px;
        width: 15px;
        height: 1px;
        background-color: #c0c0c0;
      }
    }

    span {
      padding-left: 5px;
    }

    .updated-by {
      color: #b0b0b0;
      font-size: 0.85em;

      .datetime {
        color: #888;
      }
    }

    .reference {
      padding-left: 5px;
      margin: 5px 0px;
    }

  }

  .transfer-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #e8eef5;
    padding: 6px 8px;
    border-radius: 4px;
    cursor: default;
    transition: background-color 0.2s;

    &:hover {
      background-color: #dce4ed;
    }
  }

  .transfer-info {
    display: flex;
    flex-direction: column;
  }

  .header-actions {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  button {
    border: none;
    background: transparent;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.7;
    }
  }

}
</style>
